import LoopCheckCore from '../core/loop-check';
import SessionCore from '../core/session';
import ReasonCore from '../core/reason';
import JumpCore from '../core/jump';
import Reporter from '../helpers/reporter';
import Interceptor from '../core/interceptor';
import Config from '../config';
import PageInfoManager from '../core/pageinfo-manager';
import EnvInfoManager from '../core/enviroment-manager';

export default class {
	/**
	 * 防止无限轮询
	 */
	static safeRedirect (currentPageInfo: PageInfoManager, errorTipsPageQuery: Record<string, any>): void {
		const path: string = window.location && window.location.pathname;

		// 本次访问信息记录
		const currentStackInfo: Record<string, any> = currentPageInfo.getPageInfo();
		SessionCore.addCurrentStackInfo(path, currentStackInfo);

		// 记录环境信息，环境信息在一次 session 生命周期中一般不会改变，仅首次访问时记录
		let envInfo: Record<string, any> = new EnvInfoManager().getEnvInfo();
		const envSessionKey = `${path}_envInfo`;
		let isExistEnvInfo: boolean = SessionCore.checkIsExist(envSessionKey);
		if (!isExistEnvInfo) {
			SessionCore.setItem(envSessionKey, envInfo);
		} else {
			envInfo = SessionCore.getItem(envSessionKey) || {};
		}

		// 无限轮询校验
		const isRedirectLoop: boolean = LoopCheckCore.check(path, Config.rules.protect.count, Config.rules.protect.second);
		// 无限轮询告警校验
		const isRedirectLoopWarn: boolean = LoopCheckCore.check(path, Config.rules.warning.count, Config.rules.warning.second);

		// 前置线上开关获取
		const shouldGetJumpSwitch: boolean = LoopCheckCore.check(path, Config.rules.protect.count - 3, Config.rules.protect.second);
		if (shouldGetJumpSwitch && Config.isJump) JumpCore.getJumpSwitch();

		let urlStackInfo: Record<string, any>[] = SessionCore.getStackInfo(path);
		let reason: string = ReasonCore.getReason(urlStackInfo);

		// 请求拦截，记录 Api domain
		if (!Config.disableRequestInterceptor) {
			Interceptor.intercept();
		}

		// 达到无限轮询告警 -> Cat 自定义指标上报
		if (isRedirectLoopWarn && !isRedirectLoop) {
			Reporter.report(Config.REDIRECT_LOOP_WARN, urlStackInfo, envInfo, reason, Config.rules.warning.second);
			return
		}

		// 无限轮询 -> Cat 自定义指标上报 -> 跳转提示页
		if (isRedirectLoop) {
			JumpCore.jump(reason, urlStackInfo, envInfo, Config.rules.protect.second, errorTipsPageQuery);
			return
		}

		// 仅在 Throne 环境上报自定义指标
		Config.isCunstomReporter && Reporter.customMetricReport(false)
	}
}
